<div class="meeting-minute-rows">

  @for (row of controls; track trackRow($index, row); let index = $index) {
    <div class="meeting-minute-row" [formGroup]="row">

      <div class="meeting-minute-row-header">
        <span class="meeting-minute-row-index">Risk {{ index + 1 }}</span>
        @if (!readonlyRows) {
          <button
            type="button"
            class="btn btn-outline-danger btn-icon remove-row-button"
            title="Remove risk"
            (click)="onRemoveRow(index)">
            <i class="fa fa-solid fa-trash"></i>
          </button>
        }
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-6">
          <input-field
            label="Risk detected"
            placeholder="The risk or issue raised"
            [inputFormControl]="getControl(row, 'riskDetected')"
            [type]="'text'"
            [readonly]="readonlyRows">
          </input-field>
        </div>

        <div class="col-lg-4 col-md-6">
          <input-field
            label="Description"
            placeholder="Details"
            [inputFormControl]="getControl(row, 'description')"
            [type]="'text'"
            [readonly]="readonlyRows">
          </input-field>
        </div>

        <div class="col-lg-4 col-md-6">
          <input-field
            label="Action"
            placeholder="Optional action"
            [inputFormControl]="getControl(row, 'action')"
            [type]="'text'"
            [readonly]="readonlyRows">
          </input-field>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-6">
          <div class="form-group">
            <label class="fw-bold meeting-minute-field-label">Reported by</label>
            <select-field
              [selectFormControl]="getControl(row, 'reportedByUserId')"
              [options]="userOptions">
            </select-field>
          </div>
        </div>

        <div class="col-lg-4 col-md-6">
          <input-field
            label="Reported date"
            [inputFormControl]="getControl(row, 'reportedDate')"
            [type]="'date'"
            [readonly]="readonlyRows">
          </input-field>
        </div>

        <div class="col-lg-4 col-md-6">
          <div class="form-group">
            <label class="fw-bold meeting-minute-field-label">Assigned to</label>
            <select-field
              [selectFormControl]="getControl(row, 'assignToUserId')"
              [options]="userOptions">
            </select-field>
          </div>
        </div>
      </div>

    </div>
  } @empty {
    <div class="empty-text text-center text-muted py-3">
      @if (readonlyRows) {
        This meeting minute has no risk.
      } @else {
        No risk yet. Use "Add item" to create the first one.
      }
    </div>
  }

  @if (!readonlyRows) {
    <div class="add-row-bar">
      <button type="button" class="btn btn-primary" (click)="onAddRow()">
        <i class="fa fa-plus me-1"></i>Add item
      </button>
    </div>
  }

</div>
